<!--https://hiukim.github.io/mind-ar-js-doc/tools/compile-->
<div #container class="media-collection" >
  <!-- -->
  <iframe [src]="frameSrc | safe : 'resourceUrl' " style="border:0px; width: 100%; height: 100%;" ></iframe>

</div>

<!--overlay con la controladora de la galeria-->
<app-collection-controller [collection]="collection" (indexSelected)="collectionIndexOnChanged($event)" ></app-collection-controller>
